import styled, { css } from 'styled-components';

export const VisuallyHiddenStyles = css`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  word-wrap: normal;
`;

export const VisuallyHidden = styled.span`
  ${VisuallyHiddenStyles}
`;
